import React from 'react';
import { SearchFullNamePopup, ListInfoDocumentDialog, ThongTinNguoiDungDon, ThongTinDon } from 'modules/reception';
import { Link, browserHistory } from 'react-router';
import { msg } from "constants/message";
import { LetterProcessingWorkFlow, Reception, GiaiQuyetDonThu, DuLieuHeThong } from 'api';
import { connect } from 'react-redux';
import { Toastr } from 'modules/toastr';
import { DateFormat } from 'constants/config';
import moment from 'moment';
import LoadingData from 'layout/partials/LoadingData.jsx';
import { Input } from 'components/tt-forms/common';
import { DropDownChonNguonDon } from 'components/tt-forms';
import ButtonGroup from 'modules/handle-letters/button-group';
import {ContainerFileDinhKem} from 'components/upload';
import { ConfirmDialog } from 'modules/dialog';
import { get, isEmpty } from 'lodash';

class AddHandleLetterOld extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      btnDisable: false,
      title: 'THÔNG TIN XỬ LÝ',
      huongXuLy: '',
      donId: (this.props.params.id ? this.props.params.id : 0),
      alias: '',
      params: {},
      data: {},
      validate: false,
      processType: '',

      dataLoading: false,
      taskDelete: [],
      doanDongNguoi: [],
      loadingSave: false,
      thanhLapDon: false,

      nguonDon: 'BUU_CHINH',
      loaiNguoiDungDonId: 'CA_NHAN',

      listTaiLieuVanThu: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dsTaiLieuBoSungRemove: [],
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      hasChange: false,
      dsTepDinhKemInputTaiLieu: [],
      noticeMsg: '',
      openConfirmDialog: false,
      backConfirm: false,
      isSave: false,
      saveTmp: true,
      nguonDonKhac: '',
      daLayThongTinDonId: '',
      noiCapCMNDList: this.props.noiCapCMNDList
    };
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'RESET_FORM'
    });
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      this.getDonInfo(this.props.params.id);
    }
    if (this.props.noiCapCMNDList && this.props.noiCapCMNDList.length === 0) {
      DuLieuHeThong.actions.getNoiCap.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'noiCapCMND',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    let state = this.state;
    if (nextProps.removeDonCongDanId) {
      state.taskDelete.push({
        type: 'CONG_DAN',
        id: nextProps.removeDonCongDanId
      });
    }
    if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
      state.daLayThongTinDonId = nextProps.thongTinDon.donId;
    }
    if (nextProps.noiCapCMNDList !== this.props.noiCapCMNDList) {
      state.noiCapCMNDList = nextProps.noiCapCMNDList;
    }
    let getItem = [];
    if (nextProps.editData !== this.props.editData) {
      if (nextProps.editData && nextProps.editData.listTaiLieuVanThu && nextProps.editData.listTaiLieuVanThu.length > 0) {
        getItem = nextProps.editData.listTaiLieuVanThu.filter(item => item.loaiQuyTrinh === 'THONG_TIN_DON');
        state.dsTepDinhKemInputTaiLieu = getItem;
      }
    } else {
      if (this.props.editData && this.props.editData.listTaiLieuVanThu && this.props.editData.listTaiLieuVanThu.length > 0) {
        getItem = this.props.editData.listTaiLieuVanThu.filter(item => item.loaiQuyTrinh === 'THONG_TIN_DON');
        state.dsTepDinhKemInputTaiLieu = getItem;
      }
    }

    this.setState(state);
  }

  onChangeData(data, resetTepDinhKem) {
    let checkDataBaoCao = '';
    let checkDataQuyetDinh = '';
    let checkDataBoSung = '';
    const loaiDon = data && data.thongTinDon && data.thongTinDon.loaiDonId;
    if (loaiDon === 'DON_TO_CAO') {
      checkDataBaoCao = 'Báo cáo kết quả xác minh nội dung tố cáo';
      checkDataQuyetDinh = 'Văn bản kết luận, giải quyết tố cáo';
      checkDataBoSung = 'Thông báo kết quả giải quyết tố cáo';
    } else if (loaiDon === 'DON_KHIEU_NAI') {
      checkDataBaoCao = 'Báo cáo kết quả xác minh nội dung khiếu nại';
      checkDataQuyetDinh = 'Quyết định giải quyết khiếu nại';
    } else if (loaiDon === 'DON_KIEN_NGHI_PHAN_ANH') {
      checkDataBaoCao = 'Văn bản xác minh đề xuất';
      checkDataQuyetDinh = 'Văn bản giải quyết kiến nghị, phản ánh';
    } else if (loaiDon === 'DON_TRANH_CHAP_DAT') {
      checkDataBaoCao = 'Báo cáo xác minh';
      checkDataQuyetDinh = 'Văn bản giải quyết';
    }
    this.setState({
      ...data,
      hasChange: true,
    });
    if (!resetTepDinhKem) {
      if (loaiDon === '') {
        this.setState({
          dsTepDinhKemInputTaiLieu: []
        }, () => {
          this.onFileChange(this.state.dsTepDinhKemInputTaiLieu);
        });
      }
      if (loaiDon === 'DON_TO_CAO') {
        this.setState({
          dsTepDinhKemInputTaiLieu: [
            {
              taiLieuVanThuId: '',
              ten: checkDataBoSung,
              required: false,
              checkValid: true,
              resetRequired: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            },
            {
              taiLieuVanThuId: '',
              ten: checkDataBaoCao,
              required: false,
              tenFile: '',
              checkValid: true,
              tenFileds: '',
              resetRequired: true,
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            },
            {
              taiLieuVanThuId: '',
              ten: checkDataQuyetDinh,
              required: false,
              checkValid: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              resetRequired: true,
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }
         ]
        }, () => {
          this.onFileChange(this.state.dsTepDinhKemInputTaiLieu);
        });
      }
      if (loaiDon === 'DON_KHIEU_NAI' || loaiDon === 'DON_KIEN_NGHI_PHAN_ANH' || loaiDon === 'DON_TRANH_CHAP_DAT') {
        this.setState({
          dsTepDinhKemInputTaiLieu: [
            {
              taiLieuVanThuId: '',
              ten: checkDataQuyetDinh,
              required: false,
              checkValid: true,
              resetRequired: true,
              tenFile: '',
              tenFileds: '',
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            },
            {
              taiLieuVanThuId: '',
              ten: checkDataBaoCao,
              required: false,
              checkValid: true,
              tenFile: '',
              tenFileds: '',
              resetRequired: true,
              duongDan: '',
              ngayQuyetDinh: '',
              soQuyetDinh: '',
              loaiQuyTrinh: 'THONG_TIN_DON',
              loaiTepDinhKem: 'QUYET_DINH'
            }
         ]
        }, () => {
          this.onFileChange(this.state.dsTepDinhKemInputTaiLieu);
        });
      }
    }
  }

  removeListTaiLieuVanThu(data) {
    data.forEach((item) => {
      Reception.actions.deleteTepDinhKem.request({
        id: item.taiLieuVanThuId
      });
    });
  }

  onInitComponent(data) {
    let newData = {
      ...data
    };
    this.setState({
      ...newData
    });
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value,
      hasChange: true
    });
  }

  handleChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;
    state.hasChange = true;
    this.setState(state);
  }

  handleChangeDate(name, e) {
    let state = this.state;
    if (typeof e.format === 'function') {
      state[name] = e.format(DateFormat);
    } else {
      state[name] = e;
    }
    state.hasChange = true;
    this.setState(state);
  }

  handleRemove(name, data) {
    let state = this.state;
    if (name === 'DOAN_DI_CUNG' && data.doanDiCungId) {
      state.taskDelete.push({
        type: 'DOAN_DI_CUNG',
        id: data.doanDiCungId
      });
    } else if (name === 'CONG_DAN' && data.donCongDanId) {
      state.taskDelete.push({
        type: 'CONG_DAN',
        id: data.donCongDanId
      });
    } else if (name === 'BANG_CHUNG' && data.taiLieuBangChungId) {
      state.taskDelete.push({
        type: 'BANG_CHUNG',
        id: data.taiLieuBangChungId
      });
    } else if (name === 'TEP_DINH_KEM' && data.taiLieuVanThuId) {
      state.taskDelete.push({
        type: 'TEP_DINH_KEM',
        id: data.taiLieuVanThuId
      });
    }
    state.hasChange = true;
    this.setState(state);
  }

  async phanLoaiDonCongDan(donId, onlySave) {
    let state = this.state;
    let plusData = {};
    let AddNewDCDList = [];
    let UpdateDCDList = [];
    let AddNewTLList = [];
    let UpdateTLList = [];
    let AddNewDDCList = [];
    let UpdateDDCList = [];

    if (state.loaiNguoiDungDonId === 'CO_QUAN_TO_CHUC') {
      plusData = {
        tenCoQuan: state.tenCoQuan,
        diaChiCoQuan: state.diaChiCoQuan,
        soDienThoaiCoQuan: state.soDienThoai
      };
    }

    if (this.props.nguoiDungDon) {
      this.props.nguoiDungDon.forEach((item, i) => {
        if (item.hoVaTen) {
          let nddData = this.createCongDan(item, 'NGUOI_DUNG_DON');
          let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
          if (donCdData.id) {
            UpdateDCDList.push(donCdData);
          } else {
            AddNewDCDList.push(donCdData);
          }
        }
      });
    }

    state.doanDongNguoi.forEach((item, i) => {
      if (item.hoVaTen) {
        let ddcData = this.createItemDoanDiCung(item, donId);
        if (ddcData.id) {
          UpdateDDCList.push(ddcData);
        }
        else {
          AddNewDDCList.push(ddcData);
        }
      }
    });
    this.createDSTepDinhKem(donId, state.dsTepDinhKem);
    if (state.flagUyQuyen) {
      if (state.uyQuyen && state.uyQuyen.flagLuatSu) {
        plusData.luatSu = state.uyQuyen.flagLuatSu;
        if (state.uyQuyen.luatSu.soTheLuatSu) {
          plusData.soTheLuatSu = state.uyQuyen.luatSu.soTheLuatSu;
        }
        if (state.uyQuyen.luatSu.ngayCapTheLuatSu) {
          plusData.ngayCapTheLuatSu = moment(state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
        }
        if (state.uyQuyen.luatSu.noiCapTheLuatSu) {
          plusData.noiCapTheLuatSu = state.uyQuyen.luatSu.noiCapTheLuatSu;
        }
        if (state.uyQuyen.luatSu.thongTinGioiThieu) {
          plusData.thongTinGioiThieu = state.uyQuyen.luatSu.thongTinGioiThieu;
        }
        if (state.uyQuyen && state.uyQuyen.luatSu && state.uyQuyen.luatSu.dsGiayUyQuyen) {
          state.uyQuyen.luatSu.dsGiayUyQuyen.forEach((item, i) => {
            let tlParams = this.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
            if (tlParams.id)
            UpdateTLList.push(tlParams);
            else
            AddNewTLList.push(tlParams);
          });
        }
      } else {
        plusData.luatSu = false;
      }
      let nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
      let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');
      if (donCdData.id)
        UpdateDCDList.push(donCdData);
      else
        AddNewDCDList.push(donCdData);
    }

    if (state.thongTinDon && state.thongTinDon.dsBangChung) {
      state.thongTinDon.dsBangChung.forEach((item, i) => {
        let tlParams = this.createTaiLieuBangChung(item, donId);
        if (tlParams.id)
        UpdateTLList.push(tlParams);
        else
        AddNewTLList.push(tlParams);
      });
    }

    if (AddNewDCDList.length) {
      await Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(() => {
        this.onClickClose();
      });
    }

    if (UpdateDCDList.length) {
      await Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(() => {
        this.onClickClose();
      });
    }


    if (AddNewTLList.length) {
      Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
    }
    if (UpdateTLList.length) {
      Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
    }
    if (AddNewDDCList.length) {
      Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
    }
    if (UpdateDDCList.length) {
      Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
    }

    this.setState(state);
  }

  createTaiLieuBangChung(item, donID, stcdId, buocGQ = 'TAI_LIEU_KEM_THEO') {
    let params = {
      donCu: {
        id: donID
      },
      buocGiaiQuyet: buocGQ
    }
    if (item.ten) {
      params.ten = item.ten;
      params.tenFileds = item.ten;
    }
    if (item.tinhTrang) {
      params.tinhTrangTaiLieu = item.tinhTrang;
    }
    if (item.tenFile) {
      params.tenFile = item.tenFile;
    }
    if (item.duongDan) {
      params.duongDan = item.duongDan;
    }
    if (item.required) {
      params.required = true;
    }
    if (stcdId) {
      params.soTiepCongDan = {
        id: stcdId
      };
    }
    if (item.taiLieuBangChungId) {
      params.id = item.taiLieuBangChungId;
    }
    return params;
  }

  createDonCongDan(cdData, donID, plusData, loaiCD) {
    let param = {
      phanLoaiCongDan: loaiCD,
      donCu: {
        id: donID
      }
    };
    if (cdData) {
      param = Object.assign(param, cdData);
    }
    if (plusData) {
      param = Object.assign(param, plusData);
    }
    return param;
  }

  createItemDoanDiCung(data, donId) {
    let params = {
      hoVaTen: data.hoVaTen,
      donCu: {
        id: donId
      }
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.cmndHoChieu) {
      params.cmndHoChieu = data.cmndHoChieu;
    }
    if (data.doanDiCungId) {
      params.id = data.doanDiCungId;
    }
    return params;
  }

  createCongDan(data, type) {
    let params = {
      hoVaTen: data.hoVaTen
    }
    if (data.tinhThanhId) {
      params.tinhThanh = {
        id: data.tinhThanhId
      };
    }
    if (data.quanHuyenId) {
      params.quanHuyen = {
        id: data.quanHuyenId
      };
    }
    if (data.phuongXaId) {
      params.phuongXa = {
        id: data.phuongXaId
      };
    }
    if (data.toThon) {
      params.toThon = data.toThon;
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.soCMNDHoChieu) {
      params.soCMNDHoChieu = data.soCMNDHoChieu;
    }
    if (data.noiCap) {
      params.noiCapCMND = {
        id: data.noiCap.value
      };
    }
    if (data.ngaySinh) {
      params.ngaySinh = moment(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.ngayCap) {
      params.ngayCap = moment(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.gioiTinh) {
      params.gioiTinh = data.gioiTinh === 'male' ? true : false;
    }
    if (data.quocTichId) {
      params.quocTich = {
        id: data.quocTichId
      };
    }
    if (data.danTocId) {
      params.danToc = {
        id: data.danTocId
      };
    }
    if (data.donCongDanId) {
      params.id = data.donCongDanId;
    }
    if (data.congDanId && type !== 'NGUOI_DUOC_UY_QUYEN') {
      params.congDan = {
        id: data.congDanId
      };
    }
    return params;
  }

  runDeleteTask() {
    let ddnParams = [];
    this.state.taskDelete.forEach((item, i) => {
      if (item.type === 'CONG_DAN') {
        Reception.actions.deleteDonCongDan.request({
          id: item.id
        });
      } else if (item.type === 'DOAN_DI_CUNG') {
        ddnParams.push({
          id: item.id
        });
      }
    });
    if (this.state.thongTinDon && this.state.thongTinDon.dsBangChungRemove) {
      this.state.thongTinDon.dsBangChungRemove.forEach((item) => {
        Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
    }
    if (this.state.dsTepDinhKemRemove) {
      this.state.dsTepDinhKemRemove.forEach((item) => {
        Reception.actions.deleteTepDinhKem.request({
          id: item
        });
      });
    }
    if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
      this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.forEach((item) => {
        Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
    }

    if (ddnParams.length) {
      Reception.actions.deleteDoanDiCungMulti.request(null, {
        doanDiCungs: ddnParams
      });
    }
  }

  createDon(onlySave) {
    if (this.validateSubmitForm()) {
      this.setState({isSave: onlySave}, () => {
        this.setState({
          btnSaving: onlySave,
          btnLoading: true,
          btnSaveLoading: true
        });
        let params = {
          coUyQuyen: this.state.flagUyQuyen,
          noiDung: this.state.thongTinDon.noiDung,
          loaiVuViec: this.state.thongTinDon.loaiVuViecId,
          nguonTiepNhanDon: this.state.nguonDon || null,
          loaiNguoiDungDon: this.state.loaiNguoiDungDonId,
          thanhLapDon: true,
          canBoXuLy: { id: this.props.userInfo.id },
          soNguoi: this.props.nguoiDungDon.length
        };

        if (this.state.daLayThongTinDonId) {
          params.daLayThongTinDonId = this.state.daLayThongTinDonId;
        }

        if (this.state.nguonDon === 'KHAC') {
          params.nguonDonKhac = this.state.nguonDonKhac;
        }
        if (get(this.state.thongTinDon, 'loaiDoiTuongId')) {
          params.loaiDoiTuong = get(this.state.thongTinDon, 'loaiDoiTuongId');
        }
        if (get(this.state.thongTinDon, 'loaiDonId')) {
          params.loaiDon = get(this.state.thongTinDon, 'loaiDonId');
        }

        if (!this.state.saveTmp) {
          params.saveTmp = this.state.saveTmp;
        }
        if (get(this.state.thongTinDon, 'layVuViecCu')) {
          params.layVuViecCu = get(this.state.thongTinDon, 'layVuViecCu');
        }

        if (this.state.loaiNguoiDungDonId === 'DOAN_DONG_NGUOI') {
          params.soNguoi = this.state.soNguoi;
        }
        if (get(this.state.thongTinDon, 'linhVucCap1Id')) {
          params.linhVucDonThu = { id: get(this.state.thongTinDon, 'linhVucCap1Id') };
        }
        if (get(this.state.thongTinDon, 'linhVucCap2Id')) {
          params.linhVucDonThuChiTiet = { id: get(this.state.thongTinDon, 'linhVucCap2Id') };
        }
        if (get(this.state.thongTinDon, 'linhVucChiTietKhac')) {
          params.linhVucChiTietKhac = get(this.state.thongTinDon, 'linhVucChiTietKhac');
        }

        if (get(this.state.thongTinDon, 'flagCQDaGiaiQuyet')) {
          if (get(this.state.thongTinDon, 'coQuanDaGiaiQuyetDonThu')) {
            params.coQuanDaGiaiQuyetDonThu = get(this.state.thongTinDon, 'coQuanDaGiaiQuyetDonThu');
          }
          if (get(this.state.thongTinDon, 'soVanBan')) {
            params.soVanBanDaGiaiQuyet = get(this.state.thongTinDon, 'soVanBan');
          }
          if (get(this.state.thongTinDon, 'ngayBanHanh')) {
            params.ngayBanHanhVanBanDaGiaiQuyet = moment(get(this.state.thongTinDon, 'ngayBanHanh'), 'DD/MM/YYYY').add(7, 'hours').toISOString();
          }
        }
        if (this.props.editData && get(this.props.editData, 'listTaiLieuVanThu') && JSON.stringify(this.state.dsTepDinhKemInputTaiLieu) !== JSON.stringify(get(this.props.editData, 'listTaiLieuVanThu'))) {
          this.removeListTaiLieuVanThu(get(this.props.editData, 'listTaiLieuVanThu'));
        }
        this.runDeleteTask();
        if (get(this.props.params, 'id') !== undefined) {
          return Reception.actions.updateDonCu.request({ id: get(this.props.params, 'id') }, params).then(async (res) => {
            if (!isEmpty(res.data)) {
              await this.setState({donId: res.data.donCuId});
              await this.phanLoaiDonCongDan(res.data.donCuId, onlySave);
              await Toastr(msg.xldLuu, 'success');
              await this.onClickClose();
            }
          }).catch(error => {
            if (error.response) {
              Toastr(error.response.data.errors[0].detail, 'error');
            }
            this.setState({loadingSave: false});
          });
        }
        return Reception.actions.postDonCu.request(null, params).then(async (res) => {
          if (!isEmpty(res.data)) {
            await this.setState({donId: res.data.donCuId});
            await this.phanLoaiDonCongDan(res.data.donCuId, onlySave);
            await Toastr(msg.xldLuu, 'success');
            await this.onClickClose();
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({loadingSave: false});
        });
      });
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].forEach(validator => {
      if (pass) {
        pass = validator.validate();
      }
      else {
        validator.validate();
      }
      if (!validator.validate() && get(validator, 'props.checkValid')) {
        pass = true;
      }
    });
    return pass;
  }

  /* XULYDON */
  onClickClose() {
    browserHistory.push('/xu-ly-don-cu');
  }

  handleDataForm(state) {

    let noticeMsg = state.notice;
    delete state.messege;
    this.state.params = state;
    this.state.noticeMsg = noticeMsg;
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  getMoreDonInfo(donData) {
    let newState = this.state;
    Reception.actions.getDonCuInfo.request({ id: donData.donCuId }).then(res => {
      if (res.data) {
        donData = {...donData, ...res.data};
      }
      newState.listTaiLieuVanThu = donData.listTaiLieuVanThu;

      let info = donData;
      newState.nguonDon = info.nguonDonInfo.giaTri;
      info.listNguoiDungDon.forEach((item, i) => {
        this.props.dispatch({
          type: 'CHON_CONG_DAN',
          data: item,
          donCongDanId: item.donCongDanId,
          index: i
        })
      });

      if (info.coUyQuyen) {
        this.props.dispatch({
          type: 'CHON_CONG_DAN',
          data: info.nguoiDuocUyQuyen,
          donCongDanId: info.nguoiDuocUyQuyen.donCongDanId,
          index: -1
        });
      }
      newState.donId = info.donId;
      newState.loaiNguoiDungDonId = info.loaiNguoiDungDon;

      this.props.dispatch({
        type: 'INIT_EDIT_FORM',
        data: donData
      });
    });
    this.setState(newState);
  }

  getDonInfo(donId) {
    LetterProcessingWorkFlow.actions.getDonCuDetail.request({ id: donId }).then(res => {
      if (res.data) {
        this.getMoreDonInfo(res.data);
      }
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      return GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    }
    return callback();
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      return GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    }
    return callback();
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      return GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    }
    return callback();
  }

  createDSTepDinhKem(donId, data) {
    let listAddNew = [];
    let listUpdate = [];

    data.forEach((item, i) => {
        let params = {
          donCu: { id: donId },
          loaiQuyTrinh: 'THONG_TIN_DON',
          loaiTepDinhKem: 'QUYET_DINH'
        }
        if (item.ten) {
          params.ten = item.ten;
          params.tenFileds = item.ten;
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (item.typeRequired) {
          params.typeRequired = item.typeRequired;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
        }
        if (item.taiLieuVanThuId) {
          params.id = item.taiLieuVanThuId;
          listUpdate.push(params);
        } else {
          listAddNew.push(params);
        }
    });


    if (listAddNew.length) {
      Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
    }
    if (listUpdate.length) {
      Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
    }
  }

  saveTepDinhKem(donId, callback) {
    if (this.state.dataFileDinhKem && this.state.dataFileDinhKem.length > 0) {
      this.state.dataFileDinhKem.forEach((item, i) => {
        if (item.taiLieuVanThuId && this.state.taiLieuVanThuUpdate) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            donCu: {
              id: Number(donId)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            tenFileds: item.ten,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else if (this.state.taiLieuVanThu) {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            donCu: {
              id: Number(donId)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            tenFileds: item.ten,
            duongDan: item.duongDan,
            loaiTepDinhKem: this.state.loaiTepDinhKem,
            loaiQuyTrinh: this.state.loaiQuyTrinh,
            buocGiaiQuyet: null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });
    }
    if (this.state.dataTaiLieuVanThuDelete && this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.forEach(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }
    this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
      this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
          callback();
        });
      });
    });
  }

  onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
    this.setState({
      loaiQuyTrinh: loaiQuyTrinh,
      loaiTepDinhKem: loaiTepDinhKem,
      dataFileDinhKem: tepDinhKem,
      dataTaiLieuVanThuDelete: deleteTepDinhKem
    })
  }

  handleBack(allowBack) {
    let state = this.state;
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (state.hasChange) {
        state.backConfirm = true;
        this.setState(state);
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    let state = this.state;
    state.backConfirm = false;
    this.setState(state);
  }

  onFileRemove(id, data) {
    let state = this.state;
    if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
      state.dsTaiLieuBoSungRemove = [
        ...state.dsTaiLieuBoSungRemove,
        id
      ];
      state.dsTaiLieuBoSung = data;
    } else {
      state.dsTepDinhKemRemove = [
        ...state.dsTepDinhKemRemove,
        id
      ];
      state.dsTepDinhKem = data;
    }
    this.setState(state);
  }

  onFileChange(data) {
    let state = this.state;
    if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
      state.dsTaiLieuBoSung = data;
    } else {
      state.dsTepDinhKem = data;
    }
    this.setState(state);
  }

  handleInitDataForm(state) {
    this.setState({
      params: state
    });
  }

  render() {
    let valid = (current) => {
      return current.isBefore(moment());
    };
    return (
      <div>
        <SearchFullNamePopup self={this.state} />
        <ListInfoDocumentDialog self={this.state} checkDSDC={true}/>
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div id="page" className="add-reception panel-page">
          <div className="center">
            <div className="back-foward">
              <Link onClick={this.handleBack.bind(this, false)} title="">Về trang trước</Link>
            </div>
            <div className="heading">
              <h2 className="heading-title icon-add">
                {this.props.params.type == 'them-moi' ? 'THÊM MỚI ĐƠN/ VỤ VIỆC' : ''}
                {this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA ĐƠN/ VỤ VIỆC' : ''}
              </h2>
            </div>
            {this.state.dataLoading ? (
              <LoadingData />
            ) : (
                <div className="main_page">
                  <form className="form">
                    <div className="wrapper_box">
                      <div className="box-items">
                        <div className="box-forward ">
                          <div className="container-box">
                            <div className="group-box">
                              <div className="items-form">
                                <div className="row pl10 pr10 box-top">
                                  <div className="col-12">
                                    <DropDownChonNguonDon
                                      selectedValue={this.state.nguonDon}
                                      bindValidator={this}
                                      exceptNguonDon="GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH"
                                      onChange={this.onChange.bind(this, 'nguonDon')}
                                      className="col-input mb0-18"
                                    />
                                    {
                                      this.state.nguonDon == 'KHAC' &&
                                      <Input className="col-input mb0-18 mt21" name="nguonDonKhac" placeholder="Nhập nguồn đơn khác..." maxLength={255} value={this.state.nguonDonKhac} onChange={this.onChange.bind(this, 'nguonDonKhac')}/>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ThongTinNguoiDungDon
                        onChange={this.onChangeData.bind(this)}
                        onInit={this.onInitComponent.bind(this)}
                        bindValidator={this}
                        isDonCu={true}
                        onSave={this.state.isSave}
                        onRemove={this.handleRemove.bind(this)} />
                      <ThongTinDon
                        onChange={this.onChangeData.bind(this)}
                        onInit={this.onInitComponent.bind(this)}
                        onSave={this.state.isSave}
                        bindValidator={this}
                        isDonCu={true}
                        isKiemTraTCD={false}
                        />
                      <div className="box-items">
                        <div className="items-form pldoncu prdoncu">
                          <div className="rows box-top">
                            <div className="col-12">
                              <ContainerFileDinhKem ref='containerFileDinhKem' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.dsTepDinhKemInputTaiLieu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} name="fileDinhKemTraDon" onSave={this.props.onSave}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt30 mb30">
                      <ButtonGroup
                        alias={'DONCU'}
                        donId={this.state.donId}
                        params={this.state.params}
                        processType={'XULYDONCU'}
                        onClose={this.handleBack.bind(this, false)}
                        onSave={this.createDon.bind(this, true)}
                        btnLoading={this.state.btnLoading}
                        btnSaveLoading={this.state.btnSaveLoading}
                        onClickSaveFile={this.saveTepDinhKem.bind(this)}
                        onChange={this.handleDataForm.bind(this)}
                        onInit = {this.handleInitDataForm.bind(this)}
                        validate={this.state.validate}
                        validateSubmitForm={this.validateSubmitForm.bind(this)}
                        bindValidator={this}
                        trangThaiDonDonVi={{}}
                        btnSaving={this.state.btnSaving}
                      />
                    </div>
                  </form>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

AddHandleLetterOld.defaultProps = {
  validators: {},
  noiCapCMNDList: []
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    noiCapCMNDList: state.duLieuHeThong.noiCapCMND,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId,
    editData: state.formDataTiepCongDan.editData,
    onSave: false
  };
}

export default connect(bindStateToProps)(AddHandleLetterOld);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/add-handle-letters-old/AddHandleLetterOld.jsx